import { TableRow } from '../Table/types';
import { ToggleColumn } from '../ToggleColumn';

export const StatusColumn = <T extends TableRow>({
  onChange,
  value,
  row,
}: {
  onChange: (checked: boolean, row: T) => void;
  value: boolean;
  row: T;
}) => {
  return <ToggleColumn onChange={onChange} row={row} value={value} />;
};
